import SectionActions from './SectionActions';
import SectionActionsMui from './SectionActionsMui';
import SectionButton from './SectionButton';
import SectionButtonMui from './SectionButtonMui';
import SectionContent from './SectionContent';
import SectionContentMui from './SectionContentMui';
import SectionEditButton from './SectionEditButton';
import SectionEditButtonMui from './SectionEditButtonMui';
import { SectionEmptyState } from './SectionEmptyState';
import { SectionEmptyStateMui } from './SectionEmptyStateMui';
import SectionExpandButton from './SectionExpandButton';
import SectionExpandButtonMui from './SectionExpandButtonMui';
import SectionHeader from './SectionHeader';
import SectionHeaderMui from './SectionHeaderMui';
import SectionInfoTooltip from './SectionInfoTooltip';
import SectionInfoTooltipMui from './SectionInfoTooltipMui';
import { SectionResourceGuard } from './SectionResourceGuard';
import SectionRoot from './SectionRoot';
import SectionRootMui from './SectionRootMui';
import SectionTitle from './SectionTitle';
import SectionTitleMui from './SectionTitleMui';

export * from './SectionEmptyState';
export * from './SectionEmptyStateMui';
export {
  SectionResourceGuard,
  type SectionResourceGuardProps,
} from './SectionResourceGuard';
export type {
  RegisterSectionMetadata,
  SectionMetadata,
} from './SectionContext';
export type { SectionRootProps } from './SectionRoot';
export { default as SectionButton } from './SectionButton';
export { default as SectionButtonMui } from './SectionButtonMui';
export const Section = {
  Root: SectionRoot,
  Header: SectionHeader,
  Title: SectionTitle,
  InfoTooltip: SectionInfoTooltip,
  Content: SectionContent,
  Actions: SectionActions,
  ExpandButton: SectionExpandButton,
  EditButton: SectionEditButton,
  EmptyState: SectionEmptyState,
  ResourceGuard: SectionResourceGuard,
  Button: SectionButton,
};
export const SectionMui = {
  Root: SectionRootMui,
  Header: SectionHeaderMui,
  Title: SectionTitleMui,
  InfoTooltip: SectionInfoTooltipMui,
  Content: SectionContentMui,
  Actions: SectionActionsMui,
  ExpandButton: SectionExpandButtonMui,
  EditButton: SectionEditButtonMui,
  EmptyState: SectionEmptyStateMui,
  Button: SectionButtonMui,
};
